import getPosition from '../helpers/getPosition';
import Lenis from '../helpers/Lenis';

function onReady() {
  if (window.acf) {
    let hasInitAdmin = false;

    function onAdminReady() {
      if (hasInitAdmin) return;
      hasInitAdmin = true;

      const bgFadeEls = document.querySelectorAll('[data-bg-fade]');

      bgFadeEls.forEach(el => {
        el.style.backgroundColor = el.getAttribute('data-bg-fade');

        if (el.getAttribute('data-color-fade')) {
          el.style.color = el.getAttribute('data-color-fade');
        }
      });
    }

    window.acf.addAction('render_block_preview', onAdminReady);
    return;
  }

  const bgFadeEls = [...document.querySelectorAll('[data-bg-fade]')];

  if (!bgFadeEls.length) return;

  const states = bgFadeEls.map((el, i) => ({
    el,
    i,
    top: 0,
    height: 0,
    bg: el.getAttribute('data-bg-fade'),
    color: el.getAttribute('data-color-fade')
  }));

  let latestScroll = 0;
  let currentIndex = null;
  let currentBg = null;
  let currentColor = null;
  let ticking = false;

  function onResize() {
    states.forEach(state => {
      state.top = getPosition(state.el).top;
      state.height = state.el.clientHeight;
    });
  }

  function applyBodyColors(state) {
    const nextBg = state?.bg || '';
    const nextColor = state?.color || '';

    if (nextBg !== currentBg) {
      currentBg = nextBg;

      if (nextBg) {
        document.body.style.setProperty('--background-color', nextBg);
      } else {
        document.body.style.removeProperty('--background-color');
      }
    }

    if (nextColor !== currentColor) {
      currentColor = nextColor;

      if (nextColor) {
        document.body.style.setProperty('--text-color', nextColor);
      } else {
        document.body.style.removeProperty('--text-color');
      }
    }
  }

  function getActiveIndex(scroll) {
    const middle = scroll + window.innerHeight / 2;

    for (let i = 0; i < states.length; i++) {
      const state = states[i];

      if (middle >= state.top && middle <= state.top + state.height) {
        return i;
      }
    }

    return -1;
  }

  function update(scroll) {
    latestScroll = scroll;

    const activeIndex = getActiveIndex(scroll);

    if (activeIndex === currentIndex) return;

    currentIndex = activeIndex;

    if (activeIndex > -1) {
      applyBodyColors(states[activeIndex]);
    } else {
      applyBodyColors(null);
    }
  }

  function requestUpdate(scroll) {
    latestScroll = scroll;

    if (ticking) return;

    ticking = true;

    requestAnimationFrame(() => {
      update(latestScroll);
      ticking = false;
    });
  }

  Lenis.on('scroll', e => {
    requestUpdate(e.animatedScroll);
  });

  window.addEventListener('resize', () => {
    onResize();
    requestUpdate(latestScroll);
  });

  const resizeObserver = new ResizeObserver(() => {
    onResize();
    requestUpdate(latestScroll);
  });

  resizeObserver.observe(document.body);

  states.forEach(state => {
    resizeObserver.observe(state.el);
  });

  document.querySelectorAll('img').forEach(img => {
    if (!img.complete) {
      img.addEventListener('load', () => {
        onResize();
        requestUpdate(latestScroll);
      });
    }
  });

  /**
   * Keep the original temporary inline styles.
   * This forces all bg-fade sections to start from the first bg/color,
   * then removes those inline styles after the first visual pass.
   */
  bgFadeEls.forEach(el => {
    el.style.backgroundColor = bgFadeEls[0].getAttribute('data-bg-fade');

    const firstColor = bgFadeEls[0].getAttribute('data-color-fade');

    if (firstColor) {
      el.style.color = firstColor;
    }
  });

  onResize();
  update(0);

  setTimeout(() => {
    bgFadeEls.forEach(el => {
      el.style.removeProperty('background-color');
      el.style.removeProperty('color');
    });

    onResize();
    update(latestScroll);
  }, 1000);
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  onReady();
} else {
  window.addEventListener('DOMContentLoaded', onReady);
}

export default {};